import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManagerFilter } from './ManagerFilter';

export const DesktopConsultantFilters = memo(() => {
  const { t } = useTranslation('filters');
  return <ManagerFilter placeHolder={t('manager')} />;
});
